import { render, staticRenderFns } from "./ShopOrder.vue?vue&type=template&id=783d8a64&scoped=true&"
import script from "./ShopOrder.vue?vue&type=script&lang=js&"
export * from "./ShopOrder.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrder.vue?vue&type=style&index=0&id=783d8a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783d8a64",
  null
  
)

export default component.exports